import * as Widgets from '../widgets'
import { WidgetProps } from '../widgets/widget.types'

export const componentsMap: Record<string, React.FC<WidgetProps>> = {
  ResumeCrafting: props => <Widgets.ResumeCrafting {...props} />,
  ResumeTailoring: props => <Widgets.ResumeTailoring {...props} />,
  ResumeDistribution: props => <Widgets.ResumeDistribution {...props} />,
  CoverLetterCrafting: props => <Widgets.CoverLetterCrafting {...props} />,
  JobsApplied: props => <Widgets.JobApplied {...props} />,
  JobSearchStrategy: props => <Widgets.JobSearchStartegy {...props} />,
  InterviewsPracticed: props => <Widgets.InterviewsPracticed {...props} />,
  QuestionsPracticed: props => <Widgets.QuestionsPracticed {...props} />,
  InterviewStrategy: props => <Widgets.InterviewStrategy {...props} />,
  InterviewsPassed: props => <Widgets.InterviewsPassed {...props} />,
  First90DaysPlan: props => <Widgets.First90DaysPlan {...props} />,
  GetPromotion: props => <Widgets.GetPromotion {...props} />,
  ChangeCareers: props => <Widgets.ChangeCareers {...props} />,
  _: () => <div>Default Component</div>,
}
